import React, { useState, useEffect, createContext, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
  ContactInfo, 
  Description, 
  Requisites, 
  Location,
  Error,
  Done,
  Questions } from './sections';
import { 
  Typography, 
  Modal, 
  Steps } from 'antd';
import * as Sentry from '@sentry/browser';

import * as actionCreators from '../../../../../actions/data';
export const AppContext = createContext();

const { Title } = Typography;
const { Step } = Steps;
const lastStep = 4;

const LaborumJobForm = (props) => {
  const { jobApp, shareProcessUrl, jobPortalIntegrations, handleChange, publish, visible, closeForm } = props;
  const [state, setState] = useState({
    currentStep: 0,
    loading: false,
    completedSteps: [],
    data: {
      "client": null,
      "token": null,
      "country": "CL",
      "confidential": 0,
      "domainId": null,
      "companyId": null,
      "jobId": 0,
      "description": {
          "jobAreaId": null,
          "jobDescription": "",
          "availabilityId": null,
          "workDayId": null,
          "jobValidity": null,
          "vacancies": 1,
          "contractTime": "1 mes",
          "jobTypeId": null,
          "salary": 100000,
          "showSalary": 0,
          "companyActivityId": null,
          "paymentMethod": 1,
          "jobTitle": "",
          "jobLink": null
      },
      "requisites": {
          "minimumRequirements": "Requisitos",
          "computerSkillId": null,
          "applicantProfile": null,
          "educationalLevelId": null,
          "academicSituationId": null
      },
      "location": {
          "regionId": 1,
          "countryId": null,
          "city": {
            "id": 0,
          },
          "workplace": null,
      },
      "contactInfo": {
          "companyName": "",
          "email": "",
          "contact": "",
          "contactPhone": ""
      },
      "questions": { 
      }
    }
  });

  const countryToTrabajandoCountry = (country) => {
    switch (country) {
      case 'CL':
        return 1;
      case 'CO':
        return 4;
      case 'PE':
        return 3;
      case 'AR':
        return 2;
      case 'BO':
        return 100;
      case 'BR':
        return 103;
      case 'EC':
        return 126;
      case 'PA':
        return 239;
      case 'UY':
        return 294;
      case 'VN':
        return 6;
    }
  };

  // componentDidMount
  useEffect(() => {
    const { client, token, companyId, domainId } = jobPortalIntegrations['trabajando']
    setState((prevState) => ({...prevState ,
      data: {
        ...prevState.data,
        client,
        token,
        companyId,
        domainId,
        contactInfo: {
          ...prevState.data.contactInfo,
          companyName: jobApp.business_name,
        },
        location: {
          ...prevState.data.location,
          countryId: countryToTrabajandoCountry(jobApp.location_country)
        },
        description: {
          ...prevState.data.description,
          jobTitle: jobApp.job_application,
          jobDescription: jobApp.description ? jobApp.description.replace(/(<([^>]+)>)/ig, '') : '',
          paymentMethod: jobApp.location_country === 'CL' ? 1 : 2, // pesos chilenos : dólares
          jobLink: shareProcessUrl + '?utm_source=trabajando-gw',
          companyName: jobApp.business_name,
        }
      }
    }
    ));
    if (jobApp.job_portals.trabajando) {
      setState((prevState) => ({...prevState,  data: jobApp.job_portals.trabajando }));
    }
  }, [jobApp]);

  const onChangeShowSalary = (e) => {
    let data = {...state.data}
    let description = {...data.description}
    description.showSalary = e.target.checked ? 1:0
    data.description = description
    setState((prevState) => ({...prevState, data}));
  }

  const onChange = async currentStep => {
    setState((prevState) => ({...prevState, currentStep }));
  };

  const prevStep = () => {
    setState((prevState) => ({ ...prevState, currentStep: prevState.currentStep - 1 }))
  }

  const currentContent = () => {
    const { currentStep } = state;
    const { location_country } = jobApp;

    switch (currentStep) {
      case 0:
        return <ContactInfo />
      case 1:
        return <Requisites />
      case 2: 
        return <Description onChangeShowSalary={onChangeShowSalary} isChile={location_country === 'CL'} />
      case 3:
        return <Questions savedQuestions={state.data.questions}/>
      case 4: 
        return <Location />
      case 5:
        return <Done />
      case -1:
        return <Error />
    }
  }

  const updateJobPortals = (published) => {
      let job_portals = jobApp.job_portals;
      job_portals['trabajando'] = state.data;
      job_portals['trabajando'].published = published;
      handleChange('job_portals')(job_portals);
      const url = `gamesandtests/jobapplications/${jobApp.id}/`;
      const data = { 'job_portals': job_portals };
      props.actions.updateData(props.token, url, JSON.stringify(data), 'PATCH', 'Actualizado portales de trabajo');
  }

  const saveData = (e, form, section) => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (!err) {
        const { currentStep } = state;
        setState((prevState) => ({...prevState, loading: true }));

        if (values.confidential !== undefined) {
          setState((prevState) => ({...prevState,
            data: {
              ...prevState.data,
              confidential: values.confidential ? 1 : 0
            }
          }))
        }
        setState((prevState) => {
          delete values.confidential;
          return ({...prevState,
            data: {
              ...prevState.data,
              [section]: {
                ...prevState.data[section],
                ...values
              }
          }
        })})
      }
    })
  };

  const submitData = (e, form, section) => {
    e.preventDefault();
    let errorSending = false;
    const dataToSend = state.data
    form.validateFields(async (err, values) => {
      if (!err) {
        const { currentStep } = state;
        setState((prevState) => ({ ...prevState, loading: true }));

        if (values.confidential !== undefined) {
          dataToSend.confidential = values.confidential ? 1 : 0;
        }
        dataToSend[section] = {
          ...dataToSend[section],
          ...values,
        }
        const newData = JSON.parse(JSON.stringify(dataToSend));
        setState(prevState => ({ ...prevState, data: newData }));
        if (currentStep === lastStep) {
          dataToSend.requisites.minimumRequirements = dataToSend.requisites.minimumRequirements.replaceAll('\n', '<br>');
          dataToSend.description.jobDescription = dataToSend.description.jobDescription.replaceAll('\n', '<br>');
          dataToSend.description.companyName = dataToSend.description.companyName || dataToSend.contactInfo.companyName;
          delete dataToSend.contactInfo.confidential;
          updateJobPortals(false);
          delete dataToSend.published;
          let resp = await fetch(`${jobPortalIntegrations['trabajando'].url}/jobs-v1.4/rest/json/corporate`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend),
          }).catch(e => {
            console.error(e);
            console.error(state.data);
            console.error(dataToSend);
            Sentry.captureException('Trabajando server error');
            errorSending = true;
            return;
          });
          if (!resp) {
            setState((prevState) => ({...prevState, currentStep: -1, loading: false }))
            message.error('Error de red. Consulte por favor con su especialista a cargo.');
            return;
          }
          resp = await resp.json();
          
          if (resp.status === 'OK') {
            updateJobPortals(true);
            const shouldRedirect = false;
            publish('', shouldRedirect);
          } else {
            console.error(resp);
            console.error(state.data);
            Sentry.captureException('Trabajando integration');
            message.error('Error en la integración de Trabajando.com.');
            errorSending = true
            loading = false
          }
        }

        if (errorSending) {
          setState((prevState) => ({...prevState, currentStep: -1 }))
        } else {
          onChange(currentStep + 1);
        }
        setState((prevState) => (
          {...prevState, 
          loading: false, 
          completedSteps: [...state.completedSteps, currentStep]
          }
        ));
      }
    });
  }
  const published = jobApp.job_portals ? jobApp.job_portals['trabajando'] : false
  const { currentStep, data, loading, completedSteps } = state;
  const isLastStep = currentStep <= lastStep;
  const lastStepCompleted = Math.max(...completedSteps);
  return (
      <Modal 
        visible={visible}
        onCancel={closeForm} 
        className={`pj__job-form ${!isLastStep ? 'finish' : ''}`}
        footer={false}
        centered={true}
        title={
          !isLastStep ? ( 
            false
          ) : (
            <Fragment>
              <div className='pj__job-form__headline'>
                <Title level={4}>{published ? 'Volver a ' : ''}Publicar empleo en Trabajando.com</Title>
              </div>

              <Steps
                type="navigation"
                size="small"
                current={currentStep} 
                onChange={onChange}
              >
                {['Contacto', 'Requerimientos', 'Descripción', 'Preguntas adicionales', 'Lugar'].map((title, index) => (
                  <Step 
                    key={index}
                    title={title} 
                    disabled={lastStepCompleted < index} 
                    status={completedSteps.includes(index) ? 'finish' : currentStep === index ? 'process' : 'wait'}
                  />
                ))}
              </Steps>
            </Fragment>
          )
        }
      >
        <AppContext.Provider
          value={{
            currentStep: currentStep,
            back: prevStep,
            data: data,
            submit: submitData,
            loading: loading,
            save: saveData,
          }}
        >
          {/* {published ? <Done />: this.currentContent()} */}
          {currentContent()}
        </AppContext.Provider>
      </Modal>
  )
};


const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    jobPortalIntegrations: state.auth.jobPortalIntegrations
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actionCreators, dispatch),
    dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LaborumJobForm);